import Joi from '@hapi/joi'

export const InterEstateLeafSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group Name").messages({
        "any.invalid": `Group Name cannot have invalid characters`,
        "any.required": `Group Name characters`
    }),
    factoryID: Joi.number().invalid(0).required().label("Factory").messages({
        "any.invalid": `Select Factory`,
        "any.required": `Select Factory`
    }),
    date: Joi.string().invalid("").label("Search Date")
}